import { CURRENT_USER } from "src/constants";
import { AccessByRole, AccessPerPage } from "src/models/access.model";
import { User } from "src/models/user/user.model";

export function userHasAccessToPage(functionnality: string) {
  const userData: User = JSON.parse(localStorage.getItem(CURRENT_USER));
  if (userData === null) return false;
  if (functionnality === AccessPerPage.menuDc) {
    return (userData.role.id < 3);  // candidat, consultant et TM
  }
  if (functionnality === AccessPerPage.menuEa) {
    let tempRole = (userData.role.id === 1 || userData.role.id === 2 || userData.role.id === 3); // consultant, TM // 3 (Manager) : pour les BU
    return tempRole && (userData.boondProfile !== "Sous Traitant" &&
      userData.boondProfile !== "Indépendant" &&
      userData.boondProfile !== "PL - B2B" &&
      userData.boondProfile !== "Consultant Portage Commercial");
  }
  if (functionnality === AccessPerPage.ficheDc) {
    return (userData.role.id !== 7);  // tout sauf support
  }
  if (functionnality === AccessPerPage.createDc) {
    return (userData.role.id < 4 || userData.role.id === 8);  // candidat, consultant, TM, Manager et recruteur
  }
  if (functionnality === AccessPerPage.ficheEa) {
    let tempRoleAccess = (userData.role.id > 0 && userData.role.id < 7);  // Tout sauf candidat et support
    return tempRoleAccess && (userData.boondProfile !== "Sous Traitant" &&
      userData.boondProfile !== "Indépendant" &&
      userData.boondProfile !== "PL - B2B" &&
      userData.boondProfile !== "Consultant Portage Commercial");
  }
  if (functionnality === AccessPerPage.ficheEepBm) {
    return (
      userData.role.id === 3 || ([4, 5, 6].includes(userData.role.id) && userData.isEepmanagerAcces === true)
    );
  }
  if (functionnality === AccessPerPage.menuManagement) {
    return (userData.role.id > 2 && userData.role.id !== 7);  // manager, direction, DPO, RH
  }
  if (functionnality === AccessPerPage.managementCollaborators) {
    return (userData.role.id > 1 && userData.role.id !== 7);  // manager, TM, direction, DPO, RH
  }
  if (functionnality === AccessPerPage.managementCandidats) {
    return (userData.role.id >= 3); // Evo #42608 : >= Manager
  }
  if (functionnality === AccessPerPage.managementSkills) {
    return (userData.role.id > 3 && userData.role.id < 7);  // direction, DPO, RH
  }
  if (functionnality === AccessPerPage.managementAdministration) {
    return (userData.role.id > 3 && userData.role.id < 7);  // direction, DPO, RH
  }
  if (functionnality === AccessPerPage.exportCertifications) {
    return (userData.idRoleInternal == 1 || userData.idRoleInternal == 2);  // Admin, Export
  }
  if (functionnality === AccessPerPage.logsCv2Dc) {
    return (userData.idRoleInternal == 1 || userData.idRoleInternal == 2);  // Admin, Export
  }
  if (functionnality === AccessPerPage.droitDAcces) {
    return (userData.idRoleInternal === 1); // Admin
  }
  if (functionnality === AccessPerPage.manageManager) {
    return (
      // userData.role.id === 3 || ([4, 5, 6].includes(userData.role.id) && userData.isEepmanagerAcces === true)
      (userData.role.id >= 3 && userData.role.id < 7) // Manager, Direction, RH, DPO
    );
  }
  if (functionnality === AccessPerPage.listEEPManager) {
    return (
      (userData.role.id > 3 && userData.role.id < 7) && userData.isEepmanagerAcces === true // (direction, DPO, RH) + isEepmanagerAcces 
    );
  }
  return false;
}

export function userHasPermission(functionnality: string) {
  const userData: User = JSON.parse(localStorage.getItem(CURRENT_USER));
  if (userData === null) return false;
  if (functionnality === AccessByRole.updateDc) {
    return (userData.role.id !== 7);  // Tout sauf direction et support
  }
  if (functionnality === AccessByRole.updateSubmittedDc) {
    return (userData.role.id === 0 || userData.role.id === 1 || userData.role.id === 2 || userData.role.id === 3 || userData.role.id === 4 || userData.role.id === 5 || userData.role.id === 6 || userData.role.id === 8);  //0, 1, 4, TM, manager, dpo, rh, recruiter
  }
  if (functionnality === AccessByRole.updateValidatedDc) {
    return (userData.role.id === 2 || userData.role.id === 3 || userData.role.id === 5 || userData.role.id === 6 || userData.role.id === 8);  // TM, manager, dpo, rh, recruiter
  }
  if (functionnality === AccessByRole.submitDc) {
    return (userData.role.id !== 7);  // Tout sauf direction et support
  }
  if (functionnality === AccessByRole.validateDc) {
    return (userData.role.id === 2 || userData.role.id === 3 || userData.role.id === 5 || userData.role.id === 6 || userData.role.id === 8);  // TM, manager, dpo, rh, recruiter
  }
  if (functionnality === AccessByRole.all) {
    return (userData.role.id > 4 && userData.role.id !== 7);  // dpo, rh, recruiter
  }
  if (functionnality === AccessByRole.updateEa) {
    return (userData.role.id > 0 && userData.role.id !== 7);  // Tout sauf candidat et support
  }
  if (functionnality === AccessByRole.updateValidatedEa) {
    return (userData.role.id === 6);
  }
  return false;
}